import { apiHelper, PromiseHandler } from "../redux/apiHelper";
const getUserByName = (name) =>
  PromiseHandler(apiHelper("get", `/api/admin/user/search?name=${name}`));

export { getUserByName };
